import { BackgroundJobType } from 'types/graphql'

type PillLabelCopy = {
  pillActionLabel: string
  pillTerminalActionLabel: string
}

/** Mirrors api/src/services/backgroundJobs/pillTrackableJobTypes.ts */
const pillLabelCopyByType: Partial<Record<BackgroundJobType, PillLabelCopy>> = {
  BulkReassignInspections: {
    pillActionLabel: 'Reassigning inspections',
    pillTerminalActionLabel: 'Reassign',
  },
  BulkReassignRecords: {
    pillActionLabel: 'Reassigning record owner',
    pillTerminalActionLabel: 'Reassign',
  },
  BulkReassignTasks: {
    pillActionLabel: 'Reassigning tasks',
    pillTerminalActionLabel: 'Reassign',
  },
}

export const getBackgroundJobPillLabels = (type: BackgroundJobType): PillLabelCopy | null =>
  pillLabelCopyByType[type] ?? null
